(() => {
  const initHero = (root) => {
    if (!root || root.dataset.tiktokHeroReady === 'true') return;
    root.dataset.tiktokHeroReady = 'true';

    const videos = root.querySelectorAll('video');
    if (!videos.length) return;

    const playMuted = (video) => {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    videos.forEach((video) => {
      playMuted(video);
    });

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            playMuted(video);
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach((video) => observer.observe(video));
  };

  const boot = () => {
    document.querySelectorAll('[data-as-tiktok-hero]').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-as-tiktok-hero]');
    if (root) {
      delete root.dataset.tiktokHeroReady;
      initHero(root);
    }
  });
})();
